import { api } from './api.js';

export const streamsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getStreams: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "streams",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.map(({ model}) => ({ type: 'Streams', id: model.ID })),
            { type: 'Streams', id: 'LIST' },
          ]
          :
          [{ type: 'Streams', id: 'LIST' }]

      }
    }),
  }),
});

export const {
  useGetStreamsQuery,
} = streamsApi;
